<template>
  <div>
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :itemLayout="$store.state.long_itemLayout"
  >
  </x-addEdit>
  <a-button @click="submitForm">提交</a-button>
  </div>
</template>

<script>
import empty from '../../js/empty';
import mixin from '../../js/mixins';
export default {
  mixins: [mixin.fetchSelect, mixin.addEdit],
  name: 'testSetForm',
  data () {
    return {
      formKey: {
        scope_type: '',
        city_scope: '',
        community_scope: '',
        account_scope: ''
      },
      formList: [
        {
          label: '应用范围',
          inputType: 'select',
          options: [
            { label: '全部用户', value: 0 },
            { label: '指定城市', value: 1 },
            { label: '指定小区', value: 2 },
            { label: '指定用户', value: 3 }
          ],
          placeholder: '请选择应用范围',
          handle: this.handleUserRange,
          props: ['scope_type', {
            rules: [{required: true, message: '请选择用户范围'}]
          }]
        },
        {
          label: '选择城市',
          inputType: 'treeSelect',
          options: [], // options的 value是字符
          placeholder: '请选择城市',
          treeCheckable: true,
          props: ['city_scope', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          label: '选择小区',
          inputType: 'transfer',
          options: [],
          placeholder: '',
          props: ['community_scope', {
            rules: [{required: true, message: '请选择小区'}]
          }],
          titles: ['小区列表', '已选']
        },
        {
          label: '输入账号',
          inputType: 'textarea',
          extra: '多个账号以英文“,”逗号隔开',
          props: ['account_scope', {
            rules: [{required: true, message: '请输入账号'}]
          }]
        }
      ]
    };
  },
  created () {
    this.userRangeList(1, 2);
  },
  methods: {
    submitForm () {
      this.$children[0].form.validateFields((err, values) => {
        if (err) {
          console.log('err', err, values);
        }
        console.log('no err', values);
      });
    },
    /* 处理用户范围 */
    handleUserRange (val) {
      let scopeType = {
        0: { city_scope: false, community_scope: false, account_scope: false },
        1: { city_scope: true, community_scope: false, account_scope: false },
        2: { city_scope: false, community_scope: true, account_scope: false },
        3: { city_scope: false, community_scope: false, account_scope: true }
      };
      this.formList.forEach(el => {
        let props = el.props && el.props[0];
        let scopeObj = scopeType[val];
        for (let item in scopeObj) {
          if (props === item) {
            el.isShow = scopeObj[item];
          }
        }
      });
      let valType = {
        1: { city_scope: ['1144', '1158', '301', '316', '1959'] },
        2: { community_scope: ['1', '2', '3', '4', '5'] },
        3: { account_scope: '15060740100' }
      };
      if (val === 2) {
        this.$children[0].targetKeys = ['1', '2'];
      }
      empty.$emit('setForm', valType[val]);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/test/testSetForm.vue